// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.feedlistingmanagement.RentalManagerUserFeedListingManagementV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserFeedListingManagementV2WebApiHandler_createManualVersion } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  CreateManualVersionResponseV2WebDto,
  CreateManualVersionV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserFeedListingManagementV2WebApiHandler_createManualVersion_Args {
  postData: CreateManualVersionV2RequestDto;
}

export type RentalManagerUserFeedListingManagementV2WebApiHandler_createManualVersion_Options = UseMutationOptions<
  CreateManualVersionResponseV2WebDto,
  unknown,
  RentalManagerUserFeedListingManagementV2WebApiHandler_createManualVersion_Args
>;

/**
 * Create manual version of the listing
 */
export const useRentalManagerUserFeedListingManagementV2WebApiHandler_createManualVersion = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserFeedListingManagementV2WebApiHandler_createManualVersion_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserFeedListingManagementV2WebApiHandler_createManualVersion_Args) =>
      RentalManagerUserFeedListingManagementV2WebApiHandler_createManualVersion(args.postData, httpClient),
  });
};
